import * as Yup from 'yup'

export interface ICreateContractPayment {
  id?: number,
  uuid?:string 
  contract_id?:string
  contract_uuid?:string
  owner_id?:string 
  reference_date?:string
  payday?:string
  amount_paid?:string
  observations?:string 
  paid?: boolean,
  proof_payment?: File,
  
  contract?: {
    id?: number,
    uuid?: string,				
    identifier?: string,
    net_value?: string,
  }
  owner?: {
    id?: number,
    uuid?: string,
    name?: string,
  } 
  
}

const createLicenseSchemas = [
  Yup.object({
    
  }),
  // Yup.object({
  //   project_id: Yup.number().required().label('Projeto Obrigatório'),
  // }),
  // Yup.object({
  //   businessName: Yup.string().required().label('Business Name'),
  //   businessDescriptor: Yup.string().required().label('Shortened Descriptor'),
  //   businessType: Yup.string().required().label('Corporation Type'),
  //   businessEmail: Yup.string().required().label('Contact Email'),
  // }),
  // Yup.object({
  //   nameOnCard: Yup.string().required().label('Name On Card'),
  //   cardNumber: Yup.string().required().label('Card Number'),
  //   cardExpiryMonth: Yup.string().required().label('Expiration Month'),
  //   cardExpiryYear: Yup.string().required().label('Expiration Year'),
  //   cardCvv: Yup.string().required().label('CVV'),
  // }),
]

const initialValues: ICreateContractPayment = { 
  paid: true,  
  
}

export {createLicenseSchemas, initialValues}
